import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import routes from './routes'
import { userService } from '@/helpers/authservice/user.service'

Vue.use(VueRouter)
Vue.use(VueMeta, {
  keyName: 'page',
})

const router = new VueRouter({
  routes,
  mode: 'history',
  linkExactActiveClass: 'mm-active',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  const publicPages = ['/login', '/register', '/forgot-password', '/reset-password', '/review']
  const authpage = !publicPages.includes(routeTo.path)
  const reviewpage = routeTo.path.startsWith('/review')
  const loggeduser = localStorage.getItem('user')
  if (!reviewpage && authpage && !loggeduser) {
    return next('/login')
  }
  next()
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    let user = JSON.parse(localStorage.getItem('user'))
    if (user && routeTo.meta.permissions) {
      userService.getPermissions({ user_id: user.id }).then((data) => {
        if (!data.permissions.some((item) => routeTo.meta.permissions.includes(item.name))) {
          return next('/')
        }
      })
    }
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          resolve()
        }
      })
    }
  } catch (error) {
    return
  }
  next()
})

export default router
